import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { transferWorkspaceOwnership } from '../../../api/workspaces/permissions/transferOwnership/transferOwnership';

export const useTransferWorkspaceOwnership = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: transferWorkspaceOwnership,
    onSuccess: () => {
      return queryClient.invalidateQueries(workspaceKeys.all);
    },
  });
};
